$(document).ready(function(){

  gsap.registerPlugin(ScrollTrigger);


  var vw = $(window).width();

  /*
  setTimeout(function(){

    $('.icon-search').click(function(e){
    var t = $(this).attr('data-product-id');

    const host = document.querySelector('#btn-'+t); // the shadow host element
    const btn = host.shadowRoot.querySelector('button');          // selector INSIDE shadow dom
    btn.click();
    
    return false;
    e.preventDefault();
    
  });

  },3000);
  */


  $('.product-badges__badge').each(function(){
    var t = $(this).text();
    var x = t.toLowerCase()
    .trim()
    .replace(/\s+/g, '-')     // spaces → hyphens

    $(this).addClass(x);

  });

  $(document).on('click', '.icon-search', function(e) {
    e.preventDefault();

    if(vw>750) {

      var t = $(this).attr('data-product-id');

      const host = document.querySelector('#btn-' + t);

      if (!host) {
        console.warn('Host not found:', t);
        return;
      }

      // Wait for shadowRoot if needed
      const tryClick = () => {
        if (host.shadowRoot) {
          const btn = host.shadowRoot.querySelector('.chakra-portal button');

          if (btn) {
            btn.click();
          } else {
            console.warn('Button not found inside shadowRoot');
          }
        } else {
          // Retry (important for Safari / async rendering)
          setTimeout(tryClick, 100);
        }
      };

    tryClick();
    
    } else {
      window.location.href = "/pages/where-to-buy";
    }
});

  
  

  











  function getUrlVars() {
		var vars = {};
		var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
		vars[key] = value;
		});
		return vars;
	  }

	  var prodTag = getUrlVars()["filter.p.tag"];
    

    if((prodTag=='') || (prodTag==undefined) || (prodTag==null)) {
      // console.log('nothing');
    } else {
      console.log(prodTag);
      var z = prodTag.replace('+',' ');
      console.log(z);
      
      $('.filter-button').removeClass('active');
      $('[data-target="'+z+'"]').addClass('active'); 
     
    }

    /*
    if(prodTag=='New') {
      $('.filter-button').removeClass('active');
      $('[data-target='+prodTag).addClass('active');  
    }
      */
	
 
  



  $('.h-sticky-buttons a').each(function(){
    var t = $(this).text();
    $(this).html('<span>'+t+'</span>').append('<div class="gradient-animation"></div>');
    
  });


  

$(document).on('change', 'form[action*="/cart/add"] input[name="Size-AZ08rR0p5aDRBeU5LU__variant_picker_R3rGDr-9200990322876"]', function() {

  var variantId = $(this).val();
  var variants = window.productVariants || [];

  var variant = variants.find(v => v.id == variantId);

  if (variant && variant.inventory_quantity == 0) {
    outOfStockTrigger(variant);
  }

});




if($('.h-anim').length) {
  gsap.to('.h-anim',{
      y: 0,
      autoAlpha: 1,
      easing: 'power4.inOut',
      stagger: .1,
      duration: .3,
      scale: 1,
      delay: .5
  });
}



  $('barbie-text').each(function(){

    var x = $(this);
    var img = $(this).attr('src');
    var imgWidth = $(this).attr('width');
    var mobileWidth = $(this).attr('m-width');
    var t = x.text();

    x.html('<h2 class="huer-barbie-text" style="max-width:calc('+imgWidth+'/var(--vw)*100vw)"><img src="'+img+'"><span>'+t+'</span></h2>');

    
  });

  
  $('.filter-button').click(function(){

    var x = $(this).attr('data-target');

      if(x=='all') {
        $('.facets__clear-all').click();
        $('.filter-button').removeClass('active');
        $(this).addClass('active');
      } else {

        if($(this).hasClass('active')) {
          $(this).removeClass('active');
          $('[data-label="'+x+'"]').click();

          if($('.h-filter-buttons .active').length){
            
          } else {
            $('[data-target="all"]').addClass('active');
          }
          
        } else {
          $('[data-label="'+x+'"]').click();
          $('[data-target="all"]').removeClass('active');
          $(this).addClass('active');
        } 
      }

      return false;
    
  });

  


    if($('#h-review-slider').length) {
      $("#h-review-slider").bxSlider({
      auto: true,
      pause: 6000,
      speed: 200,
      adaptiveHeight: true,
    });
    }


    /* product page */
    if($('.h-product-candy-images').length) {


    
              
    }




    
    AOS.init({
			delay: 200,
			duration: 800,
			mirror: false,
			once: true
		});
    


});